module.exports = __webpack_public_path__ + "static/media/Reporting16.3e6cf056.png";